<template>
 <Head>
    <title>Create Announcement | {{$page.props.appName}}</title>
    <meta name="description" :content="'Create Announcements ' + $page.props.appName">
  </Head>
  <div class="p-3">
    <div class="bg-gray-100 rounded-md shadow overflow-hidden max-w-3xl p-3">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

         <div class="pr-6 pb-2 w-full lg:w-1/2">
            <label for="fileupload" class="form-label">Document</label>
            <input type="file" name="fileupload" ref="fileupload" class="block"   @change="handleFileUpload" accept="image/*">
          
          </div>
          </div>
      <form @submit.prevent="store">
        
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Announcement Title</label>
            <input v-model="this.form.announcement_title" type="text" class="form-input" placeholder="Enter your title here"/>
          </div>
            <div class="pr-6 pb-8 w-full lg:w-full">
            <label for="text-input-19" class="form-label">Announcement Message:</label>
            <textarea cols="30" rows="10" v-model="this.form.announcement_message" id="text-input-19" type="text" class="form-input" placeholder="Message here"/>
          </div>
        <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-19" class="form-label">Target Audience:</label>
            <select name="" class="form-select" id="" v-model="this.form.announcement_group">
              <option value="ALL">ALL</option>
              <option :value="department.id"  v-for="department in departments" :key="department.id">{{department.department_name}}</option>
            </select>
          </div>
          <div class="w-full">
            <button type="submit" class="bg-black text-white font-bold p-2 ml-6 mt-3 float-right" :disabled="form.processing">CREATE ANNOUNCEMENT </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from '@inertiajs/inertia-vue3'

export default {
  layout: Layout,
  components: { Link, Pagination,Head},
  props: {
    sites: Object,
    departments: Object,
  },
  data() {
    return {
      filename : '',
      form: this.$inertia.form({
        announcement_title : null,
        announcement_message : null,
        announcement_group : "ALL",
        file : null
      }),
    };
  },
  methods: {
    store() {
      this.form.post("/admin/announcements/create");
    },
    handleFileUpload(e) {
      const file = e.target.files[0];
      this.form.file = file;
    },
  },
};
</script>
     